/* =================== COMPLETA ENDEREÇO =================== */
jQuery(document).ready(function($) {
  $(".cep_completa").on("change", function() {
    var input = $(this);
    var cep = $(this).val();
    var url = $(this).data("url");
    var loading = input.prev(".campo-loading");

    $.ajax({
      url: url,
      type: "POST",
      data: {
        cep: cep
      },
      beforeSend: function() {
        loading.fadeIn();
        input.prop("disabled", true);
      },
      success: function(data) {
        console.log(data);
        loading.fadeOut();
        input.prop("disabled", false);
        try {
          var endereco = JSON.parse(data);

          $(".campo-endereco").fadeIn();

          $("#logradouro").val(endereco.logradouro);
          $("#bairro").val(endereco.bairro);
          $("#cidade").val(endereco.cidade);
          $("#estado").val(endereco.uf);

          $("#numero").focus();

          $("#logradouro")
            .parsley()
            .validate();
          $("#bairro")
            .parsley()
            .validate();
          $("#cidade")
            .parsley()
            .validate();
          $("#estado")
            .parsley()
            .validate();
        } catch (e) {
          return false;
        }
      },
      error: function(xhr, type, exception) {
        loading.fadeOut();
        input.prop("disabled", false);
        console.log("ajax error response type " + type);
      }
    });
  });
  $(".btn-busca-cep").on("click", function(e) {
    e.preventDefault();
    var btn = $(this);
    var input = $("#cep");
    var cep = input.val();
    var url = btn.data("url");

    $.ajax({
      url: url,
      type: "POST",
      data: {
        cep: cep
      },
      beforeSend: function() {
        btn.prop("disabled", true);
        btn.html('<i class="fas fa-circle-notch fa-spin"></i> &nbsp;Buscando');
        input.prop("disabled", true);
      },
      success: function(data) {
        console.log(data);
        btn.prop("disabled", false);
        btn.html('<i class="fas fa-search"></i> &nbsp;Buscar Endereço');
        input.prop("disabled", false);
        try {
          var endereco = JSON.parse(data);
          $("#logradouro").val(endereco.logradouro);
          $("#bairro").val(endereco.bairro);
          $("#cidade").val(endereco.cidade);
          $("#estado").val(endereco.uf);

          // Exceção para o form de anúncio
          /* if ($("#form-anuncio").length > 0) {
            $("#form-anuncio #estado").val(endereco.estado);
          } */

          $("#numero").focus();

          $("#logradouro")
            .parsley()
            .validate();
          $("#bairro")
            .parsley()
            .validate();
          $("#cidade")
            .parsley()
            .validate();
          $("#estado")
            .parsley()
            .validate();
        } catch (e) {
          btn.prop("disabled", false);
          btn.html('<i class="fas fa-search"></i> &nbsp;Buscar Endereço');
          input.prop("disabled", false);
          return false;
        }
      },
      error: function(xhr, type, exception) {
        btn.prop("disabled", false);
        btn.html('<i class="fas fa-search"></i> &nbsp;Buscar Endereço');
        input.prop("disabled", false);
        console.log("ajax error response type " + type);
      }
    });
  });
});
